<template>
  <validation-observer #default="{handleSubmit}">
    <b-form @submit.prevent>
      <ticket-inputs
        :ticket="ticket"
        :event-tax="eventTax"
      />

      <div>
        <b-button
          variant="outline-primary"
          class="btn-pill mr-md-1 mb-1 mb-md-0 d-block d-md-inline-block"
          tag="a"
          @click="$emit('cancel')"
        >
          Cancel
        </b-button>
        <submit-button
          v-bind="{submit,handleSubmit}"
        />
      </div>
    </b-form>
  </validation-observer>
</template>

<script>
import TicketInputs from '@/components/Tickets/TicketInputs.vue'
import SubmitButton from '@/components/FormInputs/SubmitButton.vue'
import Events from '@/compositions/Events/EventsAPI'

export default {
  name: 'TicketForm',
  components: { TicketInputs, SubmitButton },
  props: {
    ticket: { type: Object, default: () => {} },
    submit: { type: Function, default: () => {} },
  },
  data() {
    return {
      eventTax: '',
    }
  },
  computed: {
    taxTypeLookup() {
      return {
        percent: '%',
      }
    },
  },
  inject: ['selectedEvent'],
  setup() {
    const { getEventRequest } = Events()
    return { getEventRequest }
  },
  created() {
    this.getEventTax()
  },
  methods: {
    getEventTax() {
      this.getEventRequest(this.selectedEvent?.value?.id || this.$route.params.id, { embed: 'tax' }).then(res => {
        this.eventTax = `${res.data.data.tax?.value} ${this.taxTypeLookup[res.data.data.tax.type]}`
      })
    },
  },
}
</script>

<style>

</style>
